import {SignalRService} from '../signal-r.service';
import {HubConnection} from '@microsoft/signalr';
import {EventEmitter} from '@angular/core';
import {FlagActivity} from '../../../../activity-log/data/flagActivity';
import {ActivityDTO} from '../../../../activity-log/data/activityDTO';

export class SignalRFlagHandler {
  static instance: SignalRFlagHandler;
  connection: HubConnection;

  onReceive: EventEmitter<FlagActivity> = new EventEmitter<FlagActivity>();

  constructor(public signalRService: SignalRService) {
    this.signalRService = signalRService;
    SignalRFlagHandler.instance = this;
  }

  async hook(connection: HubConnection) {
    this.connection = connection;
    this.connection.on('FlagActivity', this.onFlagActivity);
  }

  onFlagActivity(json: string) {
    const data: ActivityDTO = JSON.parse(json);
    SignalRFlagHandler.instance.onReceive.emit(data.activityData as FlagActivity);
  }

}

